import React, { Component } from 'react';
import Header from './Header';
import { HashRouter } from "react-router-dom";
import NavBar from './NavBar';
import ContentArea from './ContentArea';



class Main extends Component {

    constructor(props) {
        super(props);
       
        this.state = {
          visible: false
        };
        this.handleMouseDown = this.handleMouseDown.bind(this);
        this.toggleMenu = this.toggleMenu.bind(this);
      }
       
      toggleMenu() {
        this.setState({
            visible: !this.state.visible
        });
      }

      handleMouseDown(e) {
        this.toggleMenu();
    
        e.stopPropagation();
      }

    render(){
        return (
            <HashRouter>
                <div id="main">
                
                    <div id="mainheader">
                        
                        <Header />
                        <div class="menubtn">
                            <button onMouseUp={this.handleMouseDown} class="btn-slice">
                                <div class="top"><span>Menu</span></div>
                                <div class="bottom"><span>Menu</span></div>
                            </button>
                        </div>
                    </div>
                    
                    <div id="contentaandnav">
                        <div id="navigation">
                            <NavBar handleMouseDown={this.handleMouseDown} menuVisibility={this.state.visible}/>
                        </div>
                        <div id="contentarea">
                            <div id="spare"></div>
                            <ContentArea />
                        </div>
                    </div>
                </div>
            </HashRouter>
        );
    }
}


export default Main;